module.exports = __webpack_public_path__ + "static/media/chat-processing.bb64c31f.svg";